export class RunCandidateScore {
    companyId: any;
    userId: any;
    candidateId: any;
    jobId: any;
    jobMatchId: any;
    rerunType: any;
    candidateType: any;
    constructor(companyId, userId) {
        this.companyId = companyId;
        this.userId = userId;
    }
}